var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "e-filters",
        {
          attrs: { title: _vm.$t("Filtros"), searching: _vm.fetching },
          on: { search: _vm.filterData, reset: _vm.resetFiltersLocal },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c("e-store-combo", {
                    attrs: {
                      id: "delivery-config-filter-store",
                      required: false,
                    },
                    model: {
                      value: _vm.filters.storeId,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "storeId", $$v)
                      },
                      expression: "filters.storeId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card-actions",
        {
          ref: "table-card",
          attrs: { "action-refresh": "", "show-loading": _vm.fetching },
          on: { refresh: _vm.getData },
        },
        [
          _c(
            "div",
            { attrs: { slot: "title" }, slot: "title" },
            [
              _c("e-page-size-selector", {
                attrs: { "per-page": _vm.paging.pageSize },
                on: { change: _vm.pageSizeChange },
              }),
            ],
            1
          ),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c("b-table", {
                    staticClass: "table-responsive bordered",
                    attrs: {
                      id: "delivery-config-table",
                      responsive: "",
                      striped: "",
                      "show-empty": "",
                      "empty-text": _vm.$t("Nenhuma configuração encontrada."),
                      items: _vm.rows,
                      fields: _vm.fields,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(actions)",
                        fn: function (row) {
                          return [
                            _c("e-grid-actions", {
                              attrs: {
                                "show-delete": false,
                                "show-update": _vm.$can("Update", "Store"),
                                buttons: _vm.campaignButton,
                              },
                              on: {
                                update: function ($event) {
                                  return _vm.edit(row.item)
                                },
                                campaigns: function ($event) {
                                  return _vm.goToCampaigns(row.item)
                                },
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "cell(scope)",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c(
                              "b-badge",
                              {
                                attrs: {
                                  variant:
                                    item.scope === "general"
                                      ? "light-primary"
                                      : "light-secondary",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      item.scope === "general"
                                        ? _vm.$t("Geral")
                                        : _vm.$t("Loja")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(name)",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c("feather-icon", {
                              staticClass: "mr-50",
                              attrs: {
                                icon:
                                  item.scope === "general"
                                    ? "GlobeIcon"
                                    : "HomeIcon",
                              },
                            }),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  item.scope === "general"
                                    ? _vm.$t("Geral (todas as lojas)")
                                    : item.storeName
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "cell(situation)",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c(
                              "b-badge",
                              {
                                attrs: { variant: _vm.situationVariant(item) },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.situationLabel(item)) + " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(campaignCount)",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            item.activeCampaignCount > 0
                              ? _c(
                                  "b-badge",
                                  { attrs: { variant: "light-success" } },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(item.activeCampaignCount) +
                                        " " +
                                        _vm._s(
                                          item.activeCampaignCount === 1
                                            ? _vm.$t("ativa")
                                            : _vm.$t("ativas")
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : item.campaignCount > 0
                              ? _c(
                                  "b-badge",
                                  { attrs: { variant: "light-secondary" } },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(item.campaignCount) +
                                        " " +
                                        _vm._s(
                                          item.campaignCount === 1
                                            ? _vm.$t("campanha")
                                            : _vm.$t("campanhas")
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _c("span", [_vm._v("—")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c("e-pagination-summary", {
                            attrs: {
                              "current-page": _vm.paging.currentPage,
                              "per-page": _vm.paging.pageSize,
                              total: _vm.paging.rowCount,
                              "total-on-page": _vm.paging.rowsInCurrentPage,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c("b-pagination", {
                            attrs: {
                              align: "right",
                              "total-rows": _vm.paging.rowCount,
                              "per-page": _vm.paging.pageSize,
                              "aria-controls": "delivery-config-table",
                            },
                            on: { change: _vm.pageChange },
                            model: {
                              value: _vm.paging.currentPage,
                              callback: function ($$v) {
                                _vm.$set(_vm.paging, "currentPage", $$v)
                              },
                              expression: "paging.currentPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.$can("Update", "Store")
        ? _c("FAB", {
            attrs: { "main-tooltip": _vm.$t("Configurar uma loja") },
            on: { click: _vm.newStoreConfig },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }